import React from 'react';

import icon from './desktop_share.svg';

const DesktopSharePopup: React.StatelessComponent = ({ children }) => (
  <div className="row jg-space-phlg jg-space-ptlg jg-space-pbmd jg-space-mhn">
    <div className="col-md-6">{children}</div>
    <div className="col-md-5 offset-md-1 jg-display-flex jg-flex-aic jg-space-mblg">
      <img src={icon} />
    </div>
  </div>
);

export default DesktopSharePopup;



// WEBPACK FOOTER //
// ./src/components/SharePopup/DesktopSharePopup.tsx